import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FooterService } from '../../../Services/FooterService';
import { Subscription } from 'rxjs/Subscription';

@Component({
	selector: 'app-footer-view',
	templateUrl: './footer-view.component.html',
	styleUrls: ['./footer-view.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class FooterViewComponent implements OnInit {

	private subscription: Subscription[] = [];
	footerSettings : any = {};

	constructor(private _footerService: FooterService) {
		this.subscription.push(_footerService.footerSettings.subscribe(data => {
			this.footerSettings = data;
		}));
	}

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// ./src/app/footers/footer-view/footer-view.component.ts